import { useEffect } from "react";

const useClickOutside = (refs, callback) => {
  useEffect(() => {
    const handleClickOutside = (event) => {
      let clickedInside = false;

      // Check all registered refs
      Object.values(refs.current).forEach((ref) => {
        if (ref.current && ref.current.contains(event.target)) {
          clickedInside = true;
        }
      });

      // Also allow clicks inside ".menu-list.hourse-racing-list"
      const clickedInMenuList = event.target.closest('.menu-list.hourse-racing-list');

      if (!clickedInMenuList) {
        
          callback();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [refs, callback]);
};

export default useClickOutside;
